import {
  Box,
  Container,
  Wrap,
  Text,
  List,
  ListItem,
} from '@chakra-ui/react';
import { useRef } from 'react';

import MainLayout from '@src/components/layouts/main';
import PrintablePdf from '@src/modules/performance/components/PrintablePdf';
import DataDisclaimer from '@src/modules/performance/components/DataDisclaimer';
import Pagination from '../../../components/Pagination';
import ActivityManagementPlanning from '../components/report-sections/ActivityManagementPlanning';
import ActivityManagementProcurement from '../components/report-sections/ActivityManagementProcurement';
import ActivityManagementReportHeader from '../components/report-headers/ActivityManagementReportHeader';

function ActivityManagement() {
  const printableRef = useRef();

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName="Activity Management"
              printableRef={printableRef}
              printableStyles={null}
            />
          )}
          moreInfo={(
            <>
              <Text mb={4}>This page provides two summaries for the RCA:</Text>
              <List spacing={2} mb={4} styleType="number" pl={4}>
                <ListItem>
                  The results of the independent assessment by Road Efficiency Group of the TA’s Transport Activity Management Plan (AMP) submitted to NZTA. Details of the review are in the latest AMP Review for the RCA.
                </ListItem>
                <ListItem>
                  The self assessment by the TA of their Smart Buyer procurement processes.
                </ListItem>
              </List>
            </>
          )}
        />
        <Box ref={printableRef}>
          <ActivityManagementReportHeader />
          <Wrap spacing={2} className="report-sections-wrapper">
            <ActivityManagementPlanning />
            <ActivityManagementProcurement />
          </Wrap>
        </Box>
        <DataDisclaimer />
      </Container>
    </MainLayout>
  );
}

export default ActivityManagement;
